import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import asyncComponent from '../../../util/asyncComponent';
import ContainerHeader from 'components/ContainerHeader/index';


const Properties = ({match}) => (
    <div className="app-wrapper">
        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/all`}/>
            <Route path={`${match.url}/all`} component={asyncComponent(() => import('./routes/basic/index'))}/>
            <Route path={`${match.url}/agent`} component={asyncComponent(() => import('./routes/agent/index'))}/>
            <Route
                component={asyncComponent(() => import('app/routes/extraPages/routes/404'))}/>
        </Switch>
    </div>
);

export default Properties;



// WEBPACK FOOTER //
// ./app/routes/properties/index.js